module.exports = __webpack_public_path__ + "static/img/testimony (76).63ab0324.jpg";